import type { ComponentProps } from 'react'
import { FloatIslandSheet } from '../../components/ui/FloatIslandSheet'

type VideoAppSheetProps = Omit<ComponentProps<typeof FloatIslandSheet>, 'className'>

/**
 * The single sheet shell used by the video app. Settings and creation must
 * render through this exact component so their glass, border and geometry can
 * never drift apart again.
 */
export function VideoAppSheet(props: VideoAppSheetProps) {
  return <FloatIslandSheet {...props} className="video-settings-sheet" />
}
